import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.eap._index')

export const handle = {
  name: 'eap',
  hideAppFooter: true,
  hideMembershipBanner: true,
}

export default dynamic(getClientModule, { ssr: false })
